<template>
  <div id="app" @mouseenter="me()">
    <div id="nav">
      <link rel="stylesheet" href="\css\header.css" />
      <link rel="stylesheet" href="\css\common.css" />
      <link rel="stylesheet" href="\css\index.css" />

      <Nav :navInfo="navInfo" :settings="settings"></Nav>
 
      <Consult v-if="settings.visRigth==0" :content="settings.right"></Consult>
    </div>
    <router-view />
     <ZIXUN v-if="isZixun" :showzx="isZixun"> </ZIXUN>
    <Footer :footer="footer" :settings="settings"></Footer>
  </div>
</template>
<script>
import { getSetting, gethf } from "@/api/index";

import storage from 'good-storage'
import Nav from "@/components/nav.vue";
import Footer from "@/components/footer.vue";
import Consult from "@/components/consult.vue";

export default {
  name: "Home",
  components: {
    Nav,
    Consult,
    Footer,
  },
  mounted() {

    var qiyeId = this.GetUrlParam("qiyeId");
    this.isZixun=this.GetUrlParam("isZixun")==1?true:false
    this.isZixun=this.GetUrlParam("isZixun")==1?true:false
    getSetting({ id: qiyeId }).then((response) => {
      this.settings = JSON.parse(response.msg);
      var hm = document.createElement("script");
      hm.src = this.settings.tjurl;
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);

      var el = document.querySelector("link[rel*='icon']");
      el.parentNode.removeChild(el);
      var link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "shortcut icon";
      link.href = this.settings.ico;
      document.getElementsByTagName("head")[0].appendChild(link);
    });
    //获取头部信息
    gethf({ type: 0 }).then((response) => {
      this.navInfo = JSON.parse(response.msg);
    });
    gethf({ type: 1 }).then((response) => {
      this.footer = JSON.parse(response.msg);
    });
  },
  data() {
    return {
      navInfo: [],
      info: {},
      settings: {},
      footer: {},
    isZixun:false

    };
  },

  methods: {
    me(){
      var url=window.location.href
      if(url.indexOf("linkto")==-1){
         storage.set('historyUrl', url)
      }
      
      },
    GetUrlParam(paraName) {
      var url = window.location.href.toString();
      var arrObj = url.split("?");

      if (arrObj.length > 1) {
        var arrPara = arrObj[1].split("&");
        var arr;

        for (var i = 0; i < arrPara.length; i++) {
          arr = arrPara[i].split("=");

          if (arr != null && arr[0] == paraName) {
            return arr[1];
          }
        }
        return "";
      } else {
        return "";
      }
    },
  },
};
</script>